<template>
  <div class="global-header">
    <div :class="[instructions.headerOverridingClass ? instructions.headerOverridingClass : '', 'installation-instructions__header']">
      <a v-if="backSourceIsExternal" :href="instructions.prevStepName" style="z-index: 10">
        <img
          :src="icons[iconType]"
          name="back-button-icon"
          id="back-button-icon"
          text="back-button-icon"
          class="header-back-icon"
        />
      </a>
      <router-link
        v-else
        tag="div"
        :to="backSource"
        style="z-index: 10"
      >
        <img
          :src="icons[iconType]"
          name="back-button-icon"
          id="back-button-icon"
          text="back-button-icon"
          class="header-back-icon"
        />
      </router-link>

      <p v-if="instructions.headerTitleTx || instructions.headerTitle" class="global-header__title">
        {{ instructions.headerTitleTx ? $t(instructions.headerTitleTx) : instructions.headerTitle }}
      </p>

      <router-link
        v-if="instructions.rightActionItem"
        tag="div"
        :to="{
          name: rightActionItemSource,
          query: {
            mode: $route.query.mode || 'light'
          },
        }"
        style="z-index: 10"

      >
        <p
          class="right-action-item"
          name="right-action-item-text"
          id="right-action-item-text"
          text="right-action-item-text"
        >{{ instructions.rightActionItem.tx ? $t(instructions.rightActionItem.tx) : instructions.rightActionItem.text }}</p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalHeader',
  computed: {
    rightItem() {
      // Gross: https://stackoverflow.com/a/55362597
      return JSON.parse(JSON.stringify(this.instructions.rightActionItem));
    },
    backSource() {
      const { brand, device } = this.$route.params;
      const { lastStep, mode } = this.$route.query;
      const { prevStep, prevStepName, nextStep } = this.instructions;

      const source = {
        name: prevStepName || 'instructions',
        params: {
          brand,
          device,
          step: nextStep,
        },
        query: {
          mode: mode || 'light'
        }
      };

      if (lastStep) {
        source.params.step = lastStep;
      } else if (prevStep) {
        source.params.step = prevStep;
      }

      return source;
    },
    backSourceIsExternal() {
      if (this.instructions && this.instructions.prevStepName) {
        // Check for http:// || https://
        return RegExp(/^https?:\/\//i).test(this.instructions.prevStepName);
      }
      return false;
    },
    rightActionItemSource() {
      const { brand, device } = this.$route.params;
      const { nextStep, currentStep } = this.instructions;

      const source = {
        name: this.rightItem && (this.rightItem.nextStepName || 'instructions'),
        params: {
          brand,
          device,
          step: nextStep,
        },
        query: {
          lastStep: currentStep ? currentStep : undefined,
        }
      };

      if (this.rightItem && this.rightItem.nextStep) {
        source.params.step = this.rightItem.nextStep;
      }

      return source;
    }
  },
  data() {
    return {
      icons: {
        arrowWhite: require('@/assets/images/back-arrow-white.png'),
        arrowGrey: require('@/assets/images/back-arrow-grey.png'),
        arrow: require('@/assets/images/back-arrow.png'),
        close: require('@/assets/images/close-icon.png'),
        closeBlack: require('@/assets/images/close-black.png'),
      }
    };
  },
  props: {
    iconType: {
      type: String,
      default: 'arrow'
    },
    instructions: {
      type: Object,
      required: true
    },
  }
};
</script>
